import React from 'react';
import { Row, Col } from 'reactstrap';

/* Quickly hacked as proof of concept */

const InspirationCards = () => {
	return (
		<Row className="px-0 text-center">
			<Col xs="12"className="pb-3">
				<h2>Bliv inspireret og udvid din viden med Aktiedysten</h2>
			</Col>
			<Col xs="12" md="4" className="pb-3 pb-md-0">
				<div className="p-0 inspiration_card">
					<a href="https://inspiration.aktiedysten.dk/disse-aktier-er-de-mest-handlede-paa-aktiedysten-lige-nu-2/">
						<img className="w-100" alt="Inspiration 1" src="https://static.aktiedysten.dk/imgs/inspiration/11.png" />
					</a>
				</div>
			</Col>
			<Col xs="12" md="4" className="pb-3 pb-md-0">
				<div className="p-0 inspiration_card">
					<a href="https://inspiration.aktiedysten.dk/">
						<img className="w-100" alt="Inspiration 2" src="https://static.aktiedysten.dk/imgs/inspiration/12.png" />
					</a>
				</div>
			</Col>
			<Col xs="12" md="4">
                                <div className="p-0 inspiration_card">
                                        <a href="https://inspiration.aktiedysten.dk/aktieudtryk/">
                                                <img className="w-100" alt="Inspiration 1" src="https://static.aktiedysten.dk/imgs/inspiration/13.png" />
                                        </a>
                                </div>
                        </Col>
		</Row>
	);
}

export default InspirationCards;



// WEBPACK FOOTER //
// ./src/c/Inspiration.js